import PixQRCode from '../components/PixQRCode';
import '../css/presentes.css';
import '../css/components.css';

const PresenteViaPix = () => {
  return (
    <div className="pix-page" style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Presente via PIX</h1>
      <p>O melhor presente é a presença de vocês! Mas, se desejarem me presentear, crie uma forma simples e prática: meu Pix 💌.</p><br />
      <p>Cada contribuição será transformada em memórias e sonhos realizados</p>
      <PixQRCode />
    </div>
  );
};

export default PresenteViaPix;